import React from 'react';
import {Button}  from 'react-bootstrap'
import Alert from 'react-bootstrap/Alert'

export default function Nosensors(props) {
  return(
    <Alert variant="light">
      <h4>There's nothing to see here</h4><br/>
      <p>No devices are producing data. Two suggestions:</p><br/>   
      <Button className="primary" onClick={changeSite}>Change Site</Button>
      <Button className="primary" onClick={()=>commission(props)} style={{"marginLeft":"5em"}}>
        Check Uncommissioned</Button>
    </Alert>
  )
};

function changeSite () {
  window.location='/'
}
function commission(props) {
  if (props.spaRoute)
    props.spaRoute("commission")
}